import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainer, FHEContainerScroll, FHEContainerForm, FHEReactSelect, FHEButton, FHEBoxAutoComplete } from 'data/components';
import { Logger } from 'data/common';
import memoizeOne from 'memoize-one';
import {
    AddProductTitle,
    WizardAddSensor,
    WizardAddFheProduct,
    WizardAddHeatAndCool,
    WizardAddSmartPlug,
    WizardAddDriveElec
} from './components/provisionning';

const products = {
    sensor: WizardAddSensor,
    fhe_product: WizardAddFheProduct,
    heat_and_cool: WizardAddHeatAndCool,
    smart_plug: WizardAddSmartPlug,
    drive_elec: WizardAddDriveElec
};

class ProductAdd extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        boxes: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        boxMac: PropTypes.string
    };
    static defaultProps = {
        boxMac: null
    };

    constructor(props) {
        super(props);
        const { profile, history, boxMac, boxes, location } = props;
        const userRights = profile.getIn(['user_rights', 'fhe'], []);

        Object.keys(products).map(product => {
            if (!profile.get('admin') && !userRights.includes(`addProduct_${product}`)) delete products[product];
        });

        if (Object.keys(products).length === 0) {
            Logger.verbose('Redirect to 403');
            return history.replace('/error/403');
        }

        this.state = {
            boxMac: !location.state ? null : boxMac,
            middleware: boxMac ? boxes.getIn([boxMac, 'middleware'], '') : boxes.first().get('middleware'),
            productType: null,
            provisionning: false
        };
    }
    handleChange = event => {
        const { boxes } = this.props;
        let newState = {
            [event.target.name]: event.target.value
        };
        if (event.target.name === 'boxMac') newState['middleware'] = boxes.getIn([event.target.value, 'middleware'], '');

        this.setState(newState);
    };
    handleChangeBoxAutoComplete = (field, value) => {
        value = value.replace(/:/g, '');
        this.setState({
            boxMac: value
        });
    };

    toggleProvisionning = () => {
        const { provisionning } = this.state;
        this.setState({ provisionning: !provisionning });
    };

    goBack = () => {
        const { history } = this.props;
        Logger.verbose('Redirect to backPage');
        return history.goBack();
    };

    getBoxesChoices = () => {
        const { boxes } = this.props;
        let choices = [];

        boxes.map((box, boxMac) => {
            choices.push({ mac: boxMac, id: box.get('boxId') });
        });

        return choices;
    };

    getProductsChoices = () => {
        return Object.keys(products).reduce(
            (acc, product) => [...acc, { value: product, label: Translator.translate(`general.products.productType.${product}`) }],
            []
        );
    };

    renderProvisonning = () => {
        const { productType, boxMac, middleware } = this.state;
        const WizardProduct = products[productType];
        return <WizardProduct fheCenterMac={boxMac} middleware={middleware} resetProduct={this.toggleProvisionning} goBack={this.goBack} />;
    };

    emptyFunc = () => {
        return <div />;
    };

    getSelectedProductType = memoizeOne(productType => {
        if (productType === null) {
            return null;
        } else {
            return { value: productType, label: Translator.translate(`general.products.productType.${productType}`) };
        }
    });

    handleReactSelect = event => {
        this.setState({
            productType: event.value
        });
    };

    renderForm = () => {
        const { boxMac, productType } = this.state;
        const { location, history } = this.props;

        return (
            <Grid container justify="center" alignItems="center" spacing={3}>
                {!location.state && (
                    <Grid container item sm={12} md={6} xl={4} justify="center" alignItems="center" direction="column">
                        <FHEBoxAutoComplete
                            id="boxMac"
                            baseValue={boxMac ? boxMac : ''}
                            label={Translator.translate(
                                'generic.products.addProduct.selectBoxes',
                                Translator.translate(`${history.environment}.centerName`)
                            )}
                            name="boxMac"
                            data={this.getBoxesChoices()}
                            selectData={this.handleChangeBoxAutoComplete}
                        />
                    </Grid>
                )}

                <Grid container item sm={12} md={6} xl={4} justify="center" alignItems="center" direction="column">
                    <FHEReactSelect
                        name="productType"
                        label={Translator.translate('generic.products.selectProductType')}
                        onChange={this.handleReactSelect}
                        value={this.getSelectedProductType(productType)}
                        choices={this.getProductsChoices()}
                    />
                </Grid>
                <Grid container direction="column" justify="center" alignItems="center">
                    <Grid container item sm={12} md={6} xl={4} justify="center" alignItems="center" direction="column">
                        <FHEButton
                            disabled={!boxMac || !productType}
                            tooltip={
                                !boxMac || !productType
                                    ? Translator.translate('generic.products.addProduct.startInclusion.tooltip', `${history.environment}.centerName`)
                                    : null
                            }
                            content={Translator.translate('generic.products.addProduct.startInclusion.title')}
                            clickFunction={this.toggleProvisionning}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} xl={4} justify="center" alignItems="center" direction="column">
                        <FHEButton content={Translator.translate('generic.products.addProduct.goBack')} clickFunction={this.goBack} />
                    </Grid>
                </Grid>
            </Grid>
        );
    };
    render() {
        const { boxMac, provisionning } = this.state;

        return (
            <FHEContainer withBackIcon>
                <AddProductTitle key={boxMac} boxMac={boxMac} subTitle={!!(boxMac && provisionning)} />
                <FHEContainerScroll>
                    <FHEContainerForm>{provisionning ? this.renderProvisonning() : this.renderForm()}</FHEContainerForm>
                </FHEContainerScroll>
            </FHEContainer>
        );
    }
}

function mapStateToProps(state, props) {
    const boxMac = props.location.state && props.location.state.boxMac ? props.location.state.boxMac : null;
    const boxes = state.environments.fhe.data.Boxes.get('list').filter(Box => {
        return Box.get('homeId') !== null && ['active', 'provisioned'].indexOf(Box.get('boxState')) !== -1;
    });

    return {
        profile: state.data.user,
        boxMac,
        boxes
    };
}

const styles = () => ({});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(ProductAdd)));



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/add.js